module.exports = __webpack_public_path__ + "img/tag-email.05938417.svg";